
// React Imports
import * as React from "react";
import {useState, useEffect, createContext} from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import { GridToolbarContainer, GridToolbarExport} from '@mui/x-data-grid';
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import {Avatar, Collapse, Stack, Tooltip} from "@mui/material";
import {deepOrange, deepPurple, grey, lightGreen} from "@mui/material/colors";
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import {DataGridPro, GRID_DETAIL_PANEL_TOGGLE_FIELD} from "@mui/x-data-grid-pro";
import Box from "@mui/material/Box";
import RefreshIcon from '@mui/icons-material/Refresh';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Typography from "@mui/material/Typography";


// App Imports
import {
    executeExpression, getCDPbyID,getSourcedCDP
} from "../../ContractDataPoint/ContractDataPointClient";
import {
    advance,
    advanceApproved,
    advanceContract, getBlockingGuild,
    getMissingInput
} from "../../Contract/ContractClient";
import {changeWorkQueue} from "../workQueueSlice";
import {
    evaluateUnapproved, updateRelatedContractExpressions,
    updateRelatedExpressions
} from "../../ContractDataPointValue/ContractDataPointValueClient";
import LinearIndeterminate from "../../CommonComponents/Progress";
import {changeContractDrilldownCDP} from "../../ContractDrilldown/ContractDrilldownCDP/contractDrilldownSliceCDP";
import {changeContractDrilldownCDPV} from "../../ContractDrilldown/ContractDrilldownCDPV/contractDrilldownSliceCDPV";
import {changeWorkSubmitting} from "../../Work/workSubmittingSlice";
import {changeObligationHierarchy} from "../../WorkIssuance/WorkIssuanceObligation/obligationHierarchySlice";
import {changeContractDrilldownExpandCS} from "../../ContractDrilldown/contractDrilldownSliceExpandCS";
import {getContractProductsTopLevel, getThisContractTopLevel} from "../../ExternalData/Product/ProductClient";
import {WorkQueueCdpGridColumns} from "./WorkQueueCdpGridColumns";
import CDPVGrid from "../../ContractDrilldown/ContractDrilldownCDPV/contractDrilldownCDPVGrid";
import WorkQueueDrawer from "./WorkQueueDrawer";
import {changeContractDataPoint} from "../../ContractDataPoint/contractDataPointSlice";
import {changeContractDataPointValue} from "../../ContractDataPointValue/contractDataPointValueSlice";
import WorkQueueCdpInfoDialogue from "./Info/WorkQueueCdpInfoDialogue";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";


// main function

function WorkQueueCDPGrid(props) {

    const [allWorkQueueCDP, setAllWorkQueueCDP] = useState([]);
    const [workQueueCDP, setWorkQueueCDP] = useState([]);

    const [selectedCDP, setSelectedCDP] = useState([]);
    const [workQueueCdpInfoOpen, setWorkQueueCdpInfoOpen] = useState(false);

    const expandCdpId = useSelector((state) => state.contractDrilldownSlcExpandCS.value.focusCdpId);
    const selectorContractSectionId = useSelector((state) => state.workQueueSlc.value.selectedContractSectionId);
    const selectorCdpHierarchy = useSelector((state) => state.workQueueSlc.value.selectedContractSectionHierarchy);
    const selectorContractId = useSelector((state) => state.workQueueSlc.value.selectedContractId);
    const selectorContractStatus = useSelector((state) => state.workQueueSlc.value.selectedContractStatus);
    const selectorContractProperty = useSelector((state) => state.workQueueSlc.value.selectedContractProductId);
    const selectorContractLevel = useSelector((state) => state.workQueueSlc.value.selectedContractLevel);
    const selectorContractGuild = useSelector((state) => state.workQueueSlc.value.selectedContractGuild);
    const selectorFetchTopLevel = useSelector((state) => state.workQueueSlc.value.fetchTopLevel);

    const selectorPropertyDropdownTitleId = useSelector((state) => state.workQueueSlc.value.propertyDropdownTitleId);

    const selectorWorkQueueExperience = useSelector((state) => state.workQueueSlc.value.workQueueExperience);
    const selectorFirstTimeSetup = useSelector((state) => state.workQueueSlc.value.firstTimeSetup);

    const selectorInputMissingCount = useSelector((state) => state.workQueueSlc.value.selectedContractInputMissingCount);

    const cdpFilter = useSelector((state) => state.workQueueSlc.value.workQueueCDPGridPencil);

    const selectorTriggerAdvance = useSelector((state) => state.workQueueSlc.value.triggerAdvance);
    const selectorControlsRefreshCdpGrid =  useSelector((state) => state.workQueueSlc.value.workQueueCDPGridRefresh);



    const dispatchData = useDispatch();

    const CDPcontext = createContext();

    //
    // useEffect(() => {
    //     console.log("CDP fetch triggered by cdp refresh = true");
    //     fetchWorkQueueCDP();
    //     dispatchData(changeWorkQueue({workQueueCDPGridRefresh: false}));
    // }, [useSelector((state) => state.workQueueSlc.value.workQueueCDPGridRefresh)===true]);


    // useEffect(() => {
    //     console.log("CDP fetch triggered by cdp filter");
    //     fetchWorkQueueCDP();
    // }, [cdpFilter]);


    // ***************************** SOURCE WINDOW ***************************************************************

    const fetchingCdpRef = React.useRef(false);

    const fetchWorkQueueCDP = React.useCallback(() => {
        if (selectorContractId == null || selectorContractId === 0) {
            return Promise.resolve();
        }

        return getSourcedCDP(selectorContractId)

            .then(data => {
                console.log("for Contract #", selectorContractId);
                console.log("CDP data set retrieved");
                console.log(data);
                setAllWorkQueueCDP(data);
                // setWorkQueueCDP(applyCdpFilter(data, cdpFilter));
                setWorkQueueCDP(applyCdpFilter(data));


                // const hasProperty = data.some(
                //     item =>
                //         item.dataPointId === 71 &&
                //         item.mockValue !== null &&
                //         item.mockValue !== undefined
                // );
                //
                // if (hasProperty) {
                //     dispatchData(changeWorkQueue({ contractFoldersDisplay: true }));
                // }
                //
                // let nextData = data;
                //
                // if (selectorContractSectionId !== 0 && cdpFilter === "all") {
                //     nextData = data.filter(item =>
                //         item.hierarchy.indexOf(selectorCdpHierarchy) > -1
                //     );
                // }
                //
                // if (selectorContractSectionId !== 0 && cdpFilter === "black") {
                //     nextData = data.filter(item =>
                //         (item.mockOrigin === "Input" || item.mockOrigin === "Assumption") &&
                //         item.hierarchy.indexOf(selectorCdpHierarchy) > -1
                //     );
                // }
                //
                // if (selectorContractSectionId === 0 && cdpFilter === "black") {
                //     nextData = data.filter(item =>
                //         item.mockOrigin === "Input" || item.mockOrigin === "Assumption"
                //     );
                // }
                //
                // if (selectorContractSectionId !== 0 && cdpFilter === "blue") {
                //     nextData = data.filter(item =>
                //         (item.mockOrigin === "Input" || item.mockOrigin === "Assumption") &&
                //         item.mockValue !== null &&
                //         item.hierarchy.indexOf(selectorCdpHierarchy) > -1
                //     );
                // }
                //
                // if (selectorContractSectionId === 0 && cdpFilter === "blue") {
                //     nextData = data.filter(item =>
                //         (item.mockOrigin === "Input" || item.mockOrigin === "Assumption") &&
                //         item.mockValue !== null
                //     );
                // }
                //
                // if (selectorContractSectionId !== 0 && cdpFilter === "red") {
                //     nextData = data.filter(item =>
                //         item.mockOrigin === "Input" &&
                //         item.mockValue === null &&
                //         item.hierarchy.indexOf(selectorCdpHierarchy) > -1
                //     );
                // }
                //
                // if (selectorContractSectionId === 0 && cdpFilter === "red") {
                //     nextData = data.filter(item =>
                //         item.mockOrigin === "Input" &&
                //         item.mockValue === null
                //     );
                // }
                //
                // setWorkQueueCDP(nextData);
            });
    }, [
        selectorContractId,
        selectorContractSectionId,
        selectorCdpHierarchy,
        cdpFilter,
        dispatchData
    ]);


    // const applyCdpFilter = (data, filter) => {
    //     if (filter === "red") {
    //         return data.filter(item =>
    //             item.mockOrigin === "Input" &&
    //             item.mockValue === null
    //         );
    //     }
    //
    //     if (filter === "blue") {
    //         return data.filter(item =>
    //             (item.mockOrigin === "Input" || item.mockOrigin === "Assumption") &&
    //             item.mockValue !== null
    //         );
    //     }
    //
    //     if (filter === "black") {
    //         return data.filter(item =>
    //             item.mockOrigin === "Input" || item.mockOrigin === "Assumption"
    //         );
    //     }
    //
    //     return data;
    // };


    const applyCdpFilter = React.useCallback((data) => {
        let nextData = data;

        if (selectorContractSectionId !== 0 && selectorCdpHierarchy) {
            nextData = nextData.filter(item =>
                item.hierarchy?.indexOf(selectorCdpHierarchy) > -1
            );
        }

        if (cdpFilter === "red") {
            return nextData.filter(item =>
                item.mockOrigin === "Input" &&
                item.mockValue === null
            );
        }

        if (cdpFilter === "blue") {
            return nextData.filter(item =>
                (item.mockOrigin === "Input" || item.mockOrigin === "Assumption") &&
                item.mockValue !== null
            );
        }

        if (cdpFilter === "black") {
            return nextData.filter(item =>
                item.mockOrigin === "Input" ||
                item.mockOrigin === "Assumption"
            );
        }

        return nextData;
    }, [selectorContractSectionId, selectorCdpHierarchy, cdpFilter]);

//     const fetchWorkQueueCDP = () => {
//         if (selectorContractId != null
//         ) {
//             getSourcedCDP(selectorContractId)

//                 .then(data => {
//                     console.log("for Contract #", selectorContractId);
//                     console.log("CDP data set retrieved");
//                     console.log(data);
//                     setWorkQueueCDP(data);
//
//                     const hasProperty = data.some(item => item.dataPointId === 71 && item.mockValue !== null && item.mockValue !== undefined);
//
//                     console.log("hasProperty = ", hasProperty);
//
//                     if(hasProperty === true)
//                         dispatchData(changeWorkQueue({contractFoldersDisplay: true}));
//
//                     const topRed = data.reduce((acc, item) => {
//                         const matches =
//                             item.mockOrigin === 'Input' &&
//                             (item.mockValue == null || item.mockValue === '');
//
//                         if (!matches) return acc;
//                         if (!acc || Number(item.id) < Number(acc.id)) return item;
//                         return acc;
//                     }, null);
//
//                     console.log("top red Cdp count = ", topRed);
//                     console.log("selectorWorkQueueExperience = ", selectorWorkQueueExperience);
//                     console.log("selectorFirstTimeSetup = ", selectorFirstTimeSetup);
//                     console.log("selectorPropertyDropdownTitleId = ", selectorPropertyDropdownTitleId);
//                     if(topRed === null && selectorWorkQueueExperience === "ShowMe"  && selectorFirstTimeSetup === true)
//                     {                        console.log("top red Cdp is null");
//                         console.log("new set up will trigger title lookup and contract grid to display.");
//                         console.log("selectorFirstTimeSetup BEFORE = ", selectorFirstTimeSetup);
//                         dispatchData(changeWorkQueue({
//                             newSetupContractId: selectorContractId,    fetchTopLevel: true, firstTimeSetup: false
//                         }));
//                         console.log("selectorFirstTimeSetup AFTER = ", selectorFirstTimeSetup);
//                     }
//                     else {
//                         // *************************
//                         if (selectorContractSectionId !== 0 && cdpFilter === 'all') {
//                             // setWorkQueueCDP(data.filter(data => data.contractSectionId === selectorContractSectionId));
//                             setWorkQueueCDP(data.filter(data => data.hierarchy.indexOf(selectorCdpHierarchy) > -1));
//                             // setSelectedCdps(contracts.filter(contracts => contracts.hierarchy.indexOf(data.hierarchy)  > -1
//                         }
//                         if (selectorContractSectionId !== 0 && cdpFilter === 'black') {
//                             setWorkQueueCDP(data.filter(data => (data.mockOrigin === 'Input' || data.mockOrigin === 'Assumption'
//                                     && data.hierarchy.indexOf(selectorCdpHierarchy) > -1))
//                             )
//                         }
//                         if (selectorContractSectionId === 0 && cdpFilter === 'black') {
//                             setWorkQueueCDP(data.filter(data => (data.mockOrigin === 'Input' || data.mockOrigin === 'Assumption')
//                             ))
//                         }
//                         if (selectorContractSectionId !== 0 && cdpFilter === 'blue') {
//                             setWorkQueueCDP(data.filter(data => ((data.mockOrigin === 'Input' || data.mockOrigin === 'Assumption') &&
//                                     data.mockValue !== null && data.hierarchy.indexOf(selectorCdpHierarchy) > -1))
//                             )
//                         }
//                         if (selectorContractSectionId === 0 && cdpFilter === 'blue') {
//                             setWorkQueueCDP(data.filter(data => ((data.mockOrigin === 'Input' || data.mockOrigin === 'Assumption') &&
//                                 data.mockValue !== null))
//                             )
//                         }
//                         if (selectorContractSectionId !== 0 && cdpFilter === 'red') {
//                             setWorkQueueCDP(data.filter(data => ((data.mockOrigin === 'Input') &&
//                                     data.mockValue === null && data.hierarchy.indexOf(selectorCdpHierarchy) > -1))
//                             )
//                         }
//                         if (selectorContractSectionId === 0 && cdpFilter === 'red') {
//                             setWorkQueueCDP(data.filter(data => ((data.mockOrigin === 'Input') &&
//                                 data.mockValue === null))
//                             )
//                         }
//                     }
//
// // *****************************
//
//                 })
//         }
//     };

    useEffect(() => {
        if (!selectorControlsRefreshCdpGrid) return;
        if (fetchingCdpRef.current) return;

        fetchingCdpRef.current = true;

        console.log("CDP fetch triggered by cdp refresh = true");

        fetchWorkQueueCDP().finally(() => {
            fetchingCdpRef.current = false;

            dispatchData(changeWorkQueue({
                workQueueCDPGridRefresh: false
            }));
        });
    }, [
        selectorControlsRefreshCdpGrid,
        fetchWorkQueueCDP,
        dispatchData
    ]);

    // useEffect(() => {
    //     if(selectorControlsRefreshCdpGrid === true){
    //         console.log("CDP Grid refresh triggered by Work Queue workQueueCDPGridRefresh...");
    //         fetchWorkQueueCDP();
    //         dispatchData(changeWorkQueue({workQueueCDPGridRefresh: false}));}
    // }, [useSelector((state) => state.workQueueSlc.value.workQueueCDPGridRefresh)===true]);
    //
    //
    //
    // useEffect(() => {
    //     console.log("CDP fetch triggered by cdp filter");
    //     fetchWorkQueueCDP();
    // }, [cdpFilter, fetchWorkQueueCDP]);

    //
    // const handleFilter = () => {
    //     if (cdpFilter === 'all') {
    //         dispatchData(changeWorkQueue({workQueueCDPGridPencil: 'red'}));
    //     }
    //     if (cdpFilter === 'red') {
    //         dispatchData(changeWorkQueue({workQueueCDPGridPencil: 'blue'}));
    //     }
    //     if (cdpFilter=== 'blue') {
    //         dispatchData(changeWorkQueue({workQueueCDPGridPencil: 'black'}));
    //     }
    //     if (cdpFilter === 'black') {
    //         dispatchData(changeWorkQueue({workQueueCDPGridPencil: 'all'}));
    //     }
    // }

    const handleFilter = () => {
        const nextFilter =
            cdpFilter === "all" ? "red" :
                cdpFilter === "red" ? "blue" :
                    cdpFilter === "blue" ? "black" :
                        "all";

        dispatchData(changeWorkQueue({
            workQueueCDPGridPencil: nextFilter
        }));
    };
    //
    // useEffect(() => {
    //     setWorkQueueCDP(applyCdpFilter(allWorkQueueCDP, cdpFilter));
    // }, [cdpFilter, allWorkQueueCDP]);

    useEffect(() => {
        setWorkQueueCDP(applyCdpFilter(allWorkQueueCDP));
    }, [allWorkQueueCDP, applyCdpFilter]);

    // new ChatGpt version
    const openSourceWindow = (sourceRow) => {
        // 1. Build the child URL from wherever we are right now
        const childURL   = `${window.location.origin}/ResidualsFrontend`;
        const childOrigin = new URL(childURL).origin;        // no path, no trailing slash

        console.log("Opening child window at:", childURL);

        // 2. Open the window
        const newWindow = window.open(childURL, "_blank");



        // 3. Local UI update
        dispatchData(changeContractDrilldownExpandCS({ focusCdpId: sourceRow.id }));

        // 4. Prepare exactly your original payload
        const dataToSend = {
            type: "UPDATE_DATA",
            payload: {
                contractId:          sourceRow.sourceContractId,
                contractName:        sourceRow.contractName,
                contractDescription: sourceRow.sourceContractDescription,
                contractSectionId:   sourceRow.sourceContractSectionId,
                contractSectionName: sourceRow.sourceSection,
                contractDataPointId: sourceRow.sourceContractDataPointId,
                parentSection1Id:    sourceRow.sourceParentSectionId1,
                parentSection2Id:    sourceRow.sourceParentSectionId2,
                parentSection3Id:    sourceRow.sourceParentSectionId3,
                parentSection4Id:    sourceRow.sourceParentSectionId4,
                parentSection5Id:    sourceRow.sourceParentSectionId5,
                parentSection6Id:    sourceRow.sourceParentSectionId6,
                parentSection7Id:    sourceRow.sourceParentSectionId7,
                parentSection8Id:    sourceRow.sourceParentSectionId8,
                parentSection9Id:    sourceRow.sourceParentSectionId9,
                parentSection10Id:   sourceRow.sourceParentSectionId10,
            },
        };

        const sendMessage = (tag) => {
            const now = new Date().toLocaleTimeString();
            console.log(`>>> sendMessage(${tag}) at ${now}`);

            if (!newWindow || newWindow.closed) {
                console.warn("newWindow closed or missing");
                return;
            }

            try {
                newWindow.postMessage(dataToSend, childOrigin);
                console.log("✓ Sent payload to child (", tag, ")");
            } catch (err) {
                console.error("✗ postMessage failed (", tag, "):", err);
            }
        };
        // a) try right away (cached fast loads)
        sendMessage("immediate");
        if (newWindow && typeof newWindow.addEventListener === "function") {
            newWindow.addEventListener("load", () => sendMessage("load"), { once: true });
        }
        setTimeout(() => sendMessage("timeout"), 5000);
    };

    // ******************************** END SOURCE WINDOW ************************************************





    const fetchContractTitle  = () => {
        console.log("fetchContractTitle has been triggered");
        console.log("selectorPropertyDropdownTitleId =", selectorPropertyDropdownTitleId);
        if(
         //   selectorFetchTopLevel=== true &&
            (selectorPropertyDropdownTitleId < 1 || selectorPropertyDropdownTitleId === null))
        {
            console.log("Contract used for Top Level Query = ", selectorContractId);
            getThisContractTopLevel(selectorContractId)

                .then(data => {
                    console.log("fetchContractTitle has been triggered");
                    console.log("Top Level Contract Title Data");
                    console.log(data);
                    dispatchData(changeWorkQueue({
                        propertyDropdownTitleId: data[0].id,
                        propertyDropdownTitleName: data[0].title,
                        propertyDropdownMultiSingle: data[0].multiSingle,
                        propertyDropdownExpansionDepth: data[0].expansionDepth,
                        cId: selectorContractId, workQueueExperience: "ShowMe",
                        workQueueCGridRefresh: true, workQueueCSGridRefresh: true,
                        propertySearchState: false
                        // workQueueCDPGridRefresh: true,
                    }));
                    console.log("propertyDropdownTitleId modified to equal data[0].id ", data[0].id);
                    dispatchData(changeWorkQueue({
                        propertySearchState: true
                        // workQueueCDPGridRefresh: true,
                    }))

                    // setWorkQueueCDP(data);
                })
                .then(data => {
                    getContractProductsTopLevel()
                })
                .catch(error => {
                    console.error("Error fetching CDP data:", error);
                });
        }
        };


    // useEffect(() => {
    //     console.log("Contract's top level fetch triggered by workQueueSlc.value.fetchTopLevel = true");
    //     fetchContractTitle()
    //     // handleAdvance();
    //     dispatchData(changeWorkQueue({fetchTopLevel: false}));
    // }, [useSelector((state) => state.workQueueSlc.value.fetchTopLevel === true)]);


    useEffect(() => {
        if (!selectorFetchTopLevel) return;

        console.log("Contract's top level fetch triggered by fetchTopLevel = true");

        fetchContractTitle();
        dispatchData(changeWorkQueue({ fetchTopLevel: false }));
    }, [selectorFetchTopLevel, dispatchData]);




    const [submittingCdp, setSubmittingCdp] = useState(false);





    async function handleAdvance(callback) {
        const hasValidContractId =
            selectorContractId != null && selectorContractId !== 0;

        const isStandardAdvance =
            selectorContractStatus === "NEW" ||
            selectorContractStatus === "Unapproved" ||
            selectorContractStatus === undefined;

        const isApprovedAdvance =
            selectorContractStatus === "Approved";

        console.log("advance triggered", {
            selectorContractId,
            selectorContractStatus,
            selectorContractProperty,
            selectorContractLevel,
            selectorContractGuild
        });

        if (!hasValidContractId) {
            console.log("Advance failed: invalid contract id", {
                selectorContractId
            });
            return;
        }

        if (!isStandardAdvance && !isApprovedAdvance) {
            console.log("Advance failed: unsupported contract status", {
                selectorContractId,
                selectorContractStatus
            });
            return;
        }

        /*
         * Safety check before advancing.
         */
        try {
            const blockingGuild =
                await getBlockingGuild(selectorContractId);

            if (blockingGuild !== null && blockingGuild !== undefined && blockingGuild !== '') {
                console.log(
                    "Guild-level Contract already exists on this Property: ",
                    blockingGuild
                );

                dispatchData(changeCrudSnackbar({
                    crudOpen: true,
                    crudSeverity: "error",
                    crudMessage:
                        `Guild-level Contract already exists on this Property: ${blockingGuild}.`
                }));

                return;
            }
        } catch (err) {
            console.error(
                "Failed to check for blocking Guild:",
                err
            );

            dispatchData(changeCrudSnackbar({
                crudOpen: true,
                crudSeverity: "error",
                crudMessage:
                    "Unable to verify whether the contract can be advanced."
            }));

            return;
        }

        /*
         * We only get here if the Guild check passed.
         */
        const advanceFn =
            // isApprovedAdvance ? advanceApproved : advance;
        isApprovedAdvance ? advanceApproved : advanceContract;
        dispatchData(changeWorkQueue({
            actionMenuAction: null
        }));

        setSubmittingCdp(true);

        dispatchData(changeWorkSubmitting({
            submittingCdp: true
        }));
        advanceFn(selectorContractId)
        // advanceFn(
        //     null,
        //     true,
        //     localStorage.getItem("userName"),
        //     null,
        //     selectorContractId,
        //     "Setup"
        // )
            .then(() => {
                fetchWorkQueueCDP();

                if (callback) {
                    callback();
                }
            })
            .catch(err => {
                console.error("Advance failed", err);
            })
            .finally(() => {
                setSubmittingCdp(false);

                dispatchData(changeWorkSubmitting({
                    submittingCdp: false
                }));

                dispatchData(changeWorkQueue({
                    workQueueCGridRefresh: true,
                    workQueueCGridState: true,
                    workQueueCSGridState: true
                }));
            });
    }

    //
    // function handleAdvance(callback) {
    //     const hasValidContractId = selectorContractId != null && selectorContractId !== 0;
    //
    //     const isStandardAdvance =
    //         selectorContractStatus === "NEW" ||
    //         selectorContractStatus === "Unapproved" ||
    //         selectorContractStatus === undefined;
    //
    //     const isApprovedAdvance = selectorContractStatus === "Approved";
    //
    //     console.log("advance triggered", {
    //         selectorContractId,
    //         selectorContractStatus,
    //         selectorContractProperty,
    //         selectorContractLevel,
    //         selectorContractGuild
    //     });
    //
    //     if (!hasValidContractId) {
    //         console.log("Advance failed: invalid contract id", { selectorContractId });
    //         return;
    //     }
    //
    //     if (!isStandardAdvance && !isApprovedAdvance) {
    //         console.log("Advance failed: unsupported contract status", {
    //             selectorContractId,
    //             selectorContractStatus
    //         });
    //         return;
    //     }
    //
    //     // const advanceFn = isApprovedAdvance ? advanceApproved : advanceContract;
    //
    //     const advanceFn = isApprovedAdvance ? advanceApproved : advance
    //     dispatchData(changeWorkQueue({
    //         actionMenuAction: null
    //     }));
    //
    //     setSubmittingCdp(true);
    //     dispatchData(changeWorkSubmitting({ submittingCdp: true }));
    //
    //     // advanceFn(selectorContractId)
    //     advanceFn(null, true, localStorage.getItem('userName'), null, selectorContractId, 'Setup')
    //         .then(() => {
    //             fetchWorkQueueCDP();
    //
    //             if (callback) {
    //                 callback();
    //             }
    //         })
    //         .catch(err => {
    //             console.error("Advance failed", err);
    //         })
    //         .finally(() => {
    //             setSubmittingCdp(false);
    //             dispatchData(changeWorkSubmitting({ submittingCdp: false }));
    //
    //             dispatchData(changeWorkQueue({
    //                 workQueueCGridRefresh: true,
    //                 workQueueCGridState: true,
    //                 workQueueCSGridState: true
    //             }));
    //         });
    // }

    const triggerAdvance = selectorContractId => {
        if (selectorContractId !== 0) {
            console.log("advance triggered by triggerAdvance")
            handleAdvance();
        }
    }


    const arrowTriggerAdvance = () => {
            console.log("advance triggered by clicking on arrow button")
            handleAdvance();
    }

    useEffect(() => {
        if (!selectorTriggerAdvance) return;

        console.log("Advance triggered by triggerAdvance = true");

        triggerAdvance();
        dispatchData(changeWorkQueue({ triggerAdvance: false }));
    }, [selectorTriggerAdvance, dispatchData]);

    // useEffect(() => {
    //     if(selectorTriggerAdvance === true)
    //     {
    //     console.log("Advance triggered by workQueueSlc.value.triggerAdvance = true");
    //     triggerAdvance()
    //     // handleAdvance();
    //     dispatchData(changeWorkQueue({triggerAdvance: false}));}
    // }, [useSelector((state) => state.workQueueSlc.value.triggerAdvance === true)]);



    const handleExpression = (cdp_id, cs_id, callback) => {
        executeExpression(cdp_id).then(() => {
            callback(fetchWorkQueueCDP);
            console.log("Execute Expression");
        });
    };


    const handleEvaluateUnapprovedExpressions = () => {
        setSubmittingCdp(true)
        evaluateUnapproved(selectorContractId).then(()=>{
            dispatchData(changeWorkQueue({workQueueCDPGridRefresh: true}));
        })
            .finally(()=>{setSubmittingCdp(false)});
    };

    const handleEdit = (rowData) => {

        console.log("Begin edit");
        dispatchData(changeWorkQueue({cdpId: rowData.id, dataPointName: rowData.dataPointName,
            dataType: rowData.dataType, dataPointId: rowData.dataPointId, value: rowData.mockValue,workQueueDrawerState: true,
            workQueueNewState: false, workQueueAdvanceState: false,
            selectedCdpId: rowData.id,
            selectedCdpDataPointId: rowData.dataPointId,
            selectedCdpDataPointName: rowData.dataPointName,
            selectedCdpDataType: rowData.dataType,
            selectedCdpMockValue: rowData.mockValue,
            selectedCdpValue: rowData.value,
            selectedCdpOriginalValue: rowData.value,
            selectedCdpMockOrigin: rowData.mockOrigin,
            selectedCdpDefaultValue: rowData.defaultValue,
            selectedCdpDefaultValueSource: rowData.defaultValueSource,
            selectedCdpDisplayDefaultValue: rowData.displayDefaultValue,
            selectedCdpDefaultValueValue: rowData.defaultValueValue,
            selectedCdpDisplayDefaultValueValue: rowData.displayDefaultValueValue
        }));
        console.log("Begin edit");
        console.log("rowData");
        console.log(rowData);
        console.log("Work Queue Drawer State Updated to True");
        console.log("selected contract id at open");
        console.log("input missing count", selectorInputMissingCount);
        console.log("selectorContractId", selectorContractId);

        getMissingInput(selectorContractId)

            .then(function (res) {
                    console.log("my missing count res =");
                    console.log(res);
                dispatchData(changeWorkQueue({selectedContractId: selectorContractId, selectedContractInputMissingCount: res}));
                console.log("my new input missing count =",res );
            }
            );
    }


    const handleExploreCDPV = (selectedCDP) => {
        console.log("the cdpv grid should display now because of handleExploreCDPV");
        console.log("the user probably clicked on a M for multiple records avatar");
        dispatchData(changeContractDrilldownCDP({id: selectedCDP.id}));
        dispatchData(changeContractDataPoint({dataPointName: selectedCDP.dataPointName}));
        dispatchData(changeContractDataPointValue({cdpvDrawerMode: "View"}));
        dispatchData(changeContractDrilldownCDPV({cdpvGridState: true}));
    };


    const handlePivot = (selectedCDP) => {
        console.log("Pivot multiple rows");
        console.log("selectedCDP.dataPointId ", selectedCDP.dataPointId);
        dispatchData(changeWorkQueue({selectedAttributeDataPointId: selectedCDP.dataPointId,
            selectedAttributeDataPointName: selectedCDP.dataPointName,
            cdpvPivotState: true}));
    };


    const handleExploreExternalData = (selectedCDPV) => {
//        setShowCdpvGrid(!showCdpvGrid);
        console.log("Here's the row data from clicking the external data button");
        console.log(selectedCDPV);
        console.log("Here's the cdpvId: ", selectedCDPV.cdpvId);
        console.log(selectedCDPV);
        // getCDPVbyCDPid(selectedCDPV)

        //     .then(data => {
        dispatchData(changeObligationHierarchy({cdpvId: selectedCDPV.cdpvId
            ,  externalSource: selectedCDPV.externalSource,displayValue: selectedCDPV.mockValue,
            dataPointName: selectedCDPV.dataPointName,contractName: selectedCDPV.contractName,
            reuseMarket: selectedCDPV.reuseMarket,  dataType: selectedCDPV.dataType
        }));
        // alert(selectedCDPV.externalSource);
        if(selectedCDPV.externalSource === 'financial')
        {        console.log("financial grid triggered")
            // setOpenFinancialDrawer(true);
            dispatchData(changeObligationHierarchy({financialGridOpen: true}))};
        if(selectedCDPV.externalSource === 'usage')
        {dispatchData(changeObligationHierarchy({usageGridOpen: true}))};
        if(selectedCDPV.externalSource === 'license')
        {dispatchData(changeObligationHierarchy({licenseGridOpen: true}))};
        if(selectedCDPV.externalSource === 'platform')
        {dispatchData(changeObligationHierarchy({platformGridOpen: true}))};
        if(selectedCDPV.externalSource === 'viewership')
        {dispatchData(changeObligationHierarchy({viewershipGridOpen: true}))};
        if(selectedCDPV.externalSource === 'product')
        {dispatchData(changeObligationHierarchy({productGridOpen: true}))};
        if(selectedCDPV.externalSource === 'subscriber')
        {dispatchData(changeObligationHierarchy({subscriberGridOpen: true}))};
        if(selectedCDPV.externalSource === 'cast_list')
        {dispatchData(changeObligationHierarchy({stakeholderListGridOpen: true}))};
    };

    const handleSource = (sourceCDP) => {

        // dispatchData(changeContractDrilldownSlc{cdpId: sourceCDP}))
        console.log("This is the selected Source CDP");
        console.log(sourceCDP);
        getCDPbyID(sourceCDP)

            .then(data => {
                console.log(data)});
    }

    const getTreeDataPath = (workQueueCDP) => workQueueCDP.hierarchy.split(',');

    function CustomToolbar() {
        return (

            <GridToolbarContainer>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'flex' },
                    alignContent: 'flex-end',
                    justifyContent: 'flex-end',
                    ml:30
                }}>
                    <GridToolbarExport                             fontSize="small" />
                </Box>
            </GridToolbarContainer>
        );
    }




    function DetailPanelContent() {
        return (
            <h2>TEST</h2>
        )}


    const getDetailPanelHeight = React.useCallback(() => 300, []);

    const getDetailPanelContent = React.useCallback(
        ({ row }) => <DetailPanelContent row={workQueueCDP.id} />,
        [],
    );



    const handleWorkQueueCdpInfo = () => {
        setWorkQueueCdpInfoOpen(true);
    };

    const handleCloseWorkQueueCdpInfo = () => {
        setWorkQueueCdpInfoOpen(false);
    };


    // function getDetailPanelContent() { return(<div>pppppp {workQueueCDP.mockIndicator}</div>);}

    return (
        // <div style={{ height: '100%' , width: '100%' }}>
            <div style={{ height:800 , width: 970 }}>
                <WorkQueueDrawer/>

            {submittingCdp && <LinearIndeterminate/>}
                <Box>
                {/*{useSelector((state) => state.contractDataPointValueSlc.value.cdpvDrawerContext) === "workQueue" &&*/}
                    <CDPVGrid/>
                </Box>
            <Stack direction="row" spacing={2}>
                <Tooltip title={"refresh values"}>
                <Box>
                    <RefreshIcon  color={'primary'}  style={{cursor:'pointer'}}
                                  // onClick={() => handleAllExpressions()}
                                  onClick={() => handleEvaluateUnapprovedExpressions()}
                    />
                </Box>
                </Tooltip>
                <Box>
                    <Tooltip enterDelay={1000} enterNextDelay={1000}  title={<span style={{whiteSpace: 'pre-line'}}> {"contract id: " + selectorContractId +
                        "\nClick for information." }
                                        </span>}>
                    <Typography sx={{ fontWeight: 'bold' }}
                                style={{cursor:'pointer'}}   onClick={() => handleWorkQueueCdpInfo()}
                    >Contract Data Points</Typography>
                    </Tooltip>
                        <WorkQueueCdpInfoDialogue
                            open={workQueueCdpInfoOpen}
                            onClose={handleCloseWorkQueueCdpInfo}
                        />
                </Box>
                <Tooltip title={"advance"}>
                <Box>
                    <ArrowForwardIcon  color={'primary'}  style={{cursor:'pointer'}}
                                       onClick={() => arrowTriggerAdvance( )}
                    />
                </Box>
                </Tooltip>

            </Stack>

                {/*// <h3>{topRed}</h3>*/}
            <DataGridPro
                // treeData
                // style={{ height: '100% - 20px' , width: '100%' }}
                sx={{
                    '& .MuiDataGrid-detailPanel': {
                        backgroundColor: deepOrange[100],
                    },
                }}
                style={{ height: 'calc(100% - 20px)', width: '100%' }}
                aria-label={"ContractDataPoints2"}
                rows={workQueueCDP}
                rowThreshold={0}
                getDetailPanelContent={({ row }) => (
                    <Box sx={{ p: 2,
                        bgcolor: deepOrange[100]
                        // backgroundColor: "rgb(255,204,153)"
                    }}>

                        <Box sx={{ml: 2}}>
                            <strong>Expression:</strong> {row.mockExpression}
                        </Box>
                        <br/>
                        <Box sx={{ml: 2}}>
                            <strong>Translation:</strong> {row.mockExpressionTranslation}
                        </Box>
                        <br/>
                        <Box sx={{ml: 2}}>
                            <strong>Description:</strong> {row.mockExpressionDescription}
                        </Box>
                        <br/>
                        <Box sx={{ml: 2}}>
                            <strong>Staged Expression:</strong> {row.mockStagedExpression}
                        </Box>
                        <br/>
                        <Box sx={{ml: 2}}>
                            <strong>Raw Expression:</strong> {row.mockRawExpression}
                        </Box>
                    </Box>
                )}
                getDetailPanelHeight={getDetailPanelHeight}


                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={WorkQueueCdpGridColumns({
                    handleFilter,
                    cdpFilter,
                    workQueueCDP,
                    handleExpression,
                    handleEdit,
                    selectedCDP,
                    CDPcontext,
                    expandCdpId,
                    openSourceWindow,
                    handleExploreExternalData,
                    handleExploreCDPV,
                    handlePivot
                })}
                density={"compact"}
                pageSize={50}
                rowsPerPageOptions={[50]}
                initialState={{
                    sorting: {
                        sortModel: [{ field: 'id', sort: 'asc' }],
                    },
                }}
            />

        </div>
    );


}
export default WorkQueueCDPGrid;



